export enum GeoTypes {
  MSA = 'MSAs',
  REISSubMarket = 'REIS Submarkets',
  ZIP = 'Zips',
}

export type GeoTypeKeys = keyof typeof GeoTypes;
